export default __webpack_public_path__ + "static/media/tetra.e95cbea2.obj";